$(() => {
  const emailSubscriptionForms = $('.email-subscription-form');

  emailSubscriptionForms.each(function (idx, element) {
    const form = $(element);
    const submitButton = form.find('#submit-button');
    const email = form.find('#subscription-email');
    const success = form.find('#email-success');
    const failure = form.find('#email-error');
    const clearFormTimer = 5000;

    $(submitButton).click(() => {
      $.ajax({
        type: 'POST',
        url: '/subscription',
        beforeSend: function (xhr) {
          // TODO: swap for a CSRF token
          xhr.setRequestHeader('Authorization', 'Bearer token_goes_here');
        },
        success: function () {
          success.addClass('v2-absolute v2-top-14 v2-bg-green');
          success.removeClass('v2-hidden v2-bg-transparent');
          email.addClass('v2-border-2 v2-border-green');

          setInterval(() => {
            form.trigger('reset');
            success.removeClass('v2-absolute v2-top-14 v2-bg-green');
            success.addClass('v2-hidden v2-bg-transparent');
            email.removeClass('v2-border-2 v2-border-green');
          }, clearFormTimer);
        },
        error: function () {
          failure.addClass('v2-absolute v2-top-14 v2-bg-white');
          failure.removeClass('v2-hidden v2-bg-transparent');
          email.addClass('v2-border-2 v2-border-red');

          setInterval(() => {
            form.trigger('reset');
            failure.removeClass('v2-absolute v2-top-14 v2-bg-white');
            failure.addClass('v2-hidden v2-bg-transparent');
            email.removeClass('v2-border-2 v2-border-red');
          }, clearFormTimer);
        },
        data: { email: email.val() }
      }).then((response) => {
        return response;
      });
    });
  });
});
